import { useMemo } from 'react';
import { getRequestor } from './requestor';
import { getEnvironmentInstance } from './environment-instance';
import type { CCEnvironmentOptions } from '../types';

export function useCCEnvironment({
  serviceRoot,
  store,
  middlewares,
  locale,
}: CCEnvironmentOptions) {
  return useMemo(() => {
    const overreactRequestor = getRequestor({
      serviceRoot,
      locale,
    });
    return getEnvironmentInstance(overreactRequestor, store, middlewares);
  }, [locale, middlewares, serviceRoot, store]);
}
